import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import './AboutStyles.css';

import { TypeAnimation } from "react-type-animation";
import { Fade } from "react-reveal";
import PastExperienceContainer from "../components/About/PastExperienceContainer";

export default function About() {
    // Size Handling for Type Animation Re-renders
    React.useEffect(() => {
        document.title = "About | Stone Culver";
    })

    const [width, setWidth] = useState(window.innerWidth);

    // add this useEffect hook
    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div className="about">
                <Navbar />
                <div className='about-main-container container-shadow'>
                    <div className='about-description-section'>
                        <TypeAnimation
                            sequence={[
                                '', 300, 'About Me', 1500
                            ]}
                            speed={50}
                            cursor={false}
                            className={'about-type-animation-header'} />

                        <div className='image-container'>
                            <Fade delay={350}>
                                <img className='about-img float-right img-shadow' src='/images/stone-about.webp' />
                            </Fade>
                            <Fade delay={100}>
                                <p className='text'>Hello! I'm a fullstack engineer with years of experience in the field both in managing my own projects and working alongside others. I started by learning the basics with Python and more complicated programming structures and practices with C++.</p>
                            </Fade>
                            <Fade delay={200}>
                                <p className='text'>I have professional experience using C++, C#, and Javascript as well as hobby experience with many other languages. I primarily specialize in React and React based frameworks, but I am always learning and willing to take on new challenges.</p>
                            </Fade>
                            <Fade delay={300}>
                                <p className='text'>I moved to Finland in 2018 where I lived until the summer of 2024 when I moved to Estonia where I currently live with my wife. I am working hard everyday at learning Estonian and integrating myself into Estonian society.</p>
                            </Fade>
                        </div>



                    </div>

                    <div className='about-past-experience'>
                        <Fade delay={400}>
                            <TypeAnimation
                                sequence={[
                                    '', 300, "Work I've Done", 1500
                                ]}
                                speed={50}
                                cursor={false}
                                className={'about-type-animation-header'} />
                        </Fade>
                        <div className='about-past-experience-list'>
                            <Fade delay={200}>
                                <PastExperienceContainer
                                    type={'Full Time'}
                                    duration={'2021-Present'}
                                    src={"/images/hugs-logo.png"}
                                    alt={"hearts unite to give support logo"}
                                />
                            </Fade>
                            <Fade delay={400}>
                                <PastExperienceContainer
                                    type={'Freelance'}
                                    duration={'2024-Present'}
                                    src={"/images/mrwoof-logo.png"}
                                    alt={"mr woof trimmaus logo"}
                                />
                            </Fade>
                            <Fade delay={600}>
                                <PastExperienceContainer
                                    type={'Freelance'}
                                    duration={'2025'}
                                    src={"/images/tilda-logo.png"}
                                    alt={"tilda tattuu logo"}
                                />
                            </Fade>

                            <Fade delay={800}>
                                <PastExperienceContainer
                                    type={'Sub-Contract'}
                                    duration={'2023'}
                                    src={"/images/trijicon-logo.png"}
                                    alt={"trijicon logo"}
                                />
                            </Fade>
                            <Fade delay={1000}>
                            <PastExperienceContainer
                                    type={'Freelance'}
                                    duration={'2024'}
                                    src={"/images/motherhoard-logo.png"}
                                    alt={"motherhoard logo"}
                                />
                            </Fade>

                        </div>
                    </div>

                    <div className='about-languages-section'>
                        <Fade delay={300}>
                            <TypeAnimation
                                sequence={[
                                    '', 300, "Languages I Know", 1500
                                ]}
                                speed={50}
                                cursor={false}
                                className={'about-type-animation-header'} />
                        </Fade>
                        <div className='about-img-list'>
                            <Fade delay={200}>
                                <div className='about-img-list-item-container'>
                                    <h2 className='about-img-list-header'>C2 (Native)</h2>
                                    <img className='about-language-img' src="/images/USA-flag.png"
                                        alt="pixel art usa flag" />
                                </div>
                            </Fade>
                            <Fade delay={400}>
                                <div className='about-img-list-item-container'>
                                    <h2 className='about-img-list-header'>B2 (2018-2024)</h2>
                                    <img className='about-language-img' src="/images/FI-flag.png"
                                        alt="pixel art finnish flag" />
                                </div>
                            </Fade>
                            <Fade delay={600}>
                                <div className='about-img-list-item-container'>
                                    <h2 className='about-img-list-header'>B1 (2024-Present)</h2>
                                    <img className='about-language-img' src="/images/EST-flag.png"
                                        alt="pixel art estonian flag" />
                                </div>
                            </Fade>
                        </div>

                        <div className='about-skills-section'>
                            <Fade delay={150}>
                                <TypeAnimation
                                    sequence={[
                                        '', 300, 'My Skills', 1500
                                    ]}
                                    speed={50}
                                    cursor={false}
                                    className={'about-type-animation-header'} />
                            </Fade>
                            <div className='about-skills-list'>
                                <Fade delay={100}>
                                    <img className='about-skill-image' src='/images/C-logo.png'
                                        alt="pixel art C programming language logo" />
                                </Fade>
                                <Fade delay={150}>
                                    <img className='about-skill-image' src='/images/CPP-logo.png'
                                        alt="pixel art C++ programming language logo" />
                                </Fade>
                                <Fade delay={200}>
                                    <img className='about-skill-image' src='/images/js-logo.png'
                                        alt="pixel art javascript programming language logo" />
                                </Fade>
                                <Fade delay={250}>
                                    <img className='about-skill-image' src='/images/react-logo.png'
                                        alt="pixel art react logo" />
                                </Fade>
                                <Fade delay={300}>
                                    <img className='about-skill-image' src='/images/python-logo.png'
                                        alt="pixel art python programming language logo" />
                                </Fade>
                                <Fade delay={350}>
                                    <img className='about-skill-image' src='/images/aws-logo.png'
                                        alt="pixel art amazon webservices logo" />
                                </Fade>
                                <Fade delay={400}>
                                    <img className='about-skill-image' src='/images/nextjs-logo.png'
                                        alt="pixel art nextjs framework logo" />
                                </Fade>
                                <Fade delay={450}>
                                    <img className='about-skill-image' src='/images/nodejs-logo.png'
                                        alt="pixel art nodejs logo" />
                                </Fade>
                                <Fade delay={500}>
                                    <img className='about-skill-image' src='/images/mongodb-logo.png'
                                        alt="pixel art mongodb logo" />
                                </Fade>
                            </div>
                        </div>
                        <div className="about-courses-section">
                            <TypeAnimation
                                sequence={[
                                    '', 300, "Courses I've Done", 1500
                                ]}
                                speed={50}
                                cursor={false}
                                className={'about-type-animation-header'} />
                            <div className="about-course-list">
                                <Fade delay={100}>
                                    <h2 className="about-course-list-entry">Data Structures & Algorithms using C++</h2>
                                </Fade>
                                <Fade delay={200}>
                                    <h2 className="about-course-list-entry">Creational Design Patterns in Modern C++</h2>
                                </Fade>
                                <Fade delay={300}>
                                    <h2 className="about-course-list-entry">Structural Design Patterns in Modern C++</h2>
                                </Fade>
                                <Fade delay={400}>
                                    <h2 className="about-course-list-entry">Detecting Memory Leaks in C/C++ Applications</h2>
                                </Fade>
                                <Fade delay={500}>
                                    <h2 className="about-course-list-entry">Multithreading with Modern C++</h2>
                                </Fade>
                                <Fade delay={600}>
                                    <h2 className="about-course-list-entry">Masterclass TCP/IP Mechanics</h2>
                                </Fade>
                                <Fade delay={700}>
                                    <h2 className="about-course-list-entry">Arduino Programming and Hardware Fundamentals</h2>
                                </Fade>
                                <Fade delay={800}>
                                    <h2 className="about-course-list-entry">SQL for Data Analytics and Business Intelligence</h2>
                                </Fade>
                            </div>
                        </div>

                    </div>


                </div>


                <Footer />
            </div>


        </>
    )
}